module.exports = __webpack_public_path__ + "img/logo.a776ed18.svg";